/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Report_BugInputs */



/**
* | output |
* | --- |
* | "Report a bug" |
*
* @param {Layout_Header_Report_BugInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_report_bug = /** @type {((inputs?: Layout_Header_Report_BugInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Report_BugInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler melden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Signaler un bug")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("报告问题")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("回報問題")
	if (locale === "ko") return /** @type {LocalizedString} */ ("버그 신고")
	return /** @type {LocalizedString} */ ("Report a bug")
});